import { Box } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Element } from '../../../models/system-configure-card.model'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import AddPowerMeterCard from './AddPowerMeterCard'
import SmartMeterCard from './SmartMeterCard'
import AdditionalComponentPowerMeterProductCard from './AdditionalComponentPowerMeterProductCard'
import { J1LeftarrowA, J1RightarrowA } from '@e3dc-react/icons'
import { useShopHorizontalScroll } from 'src/Libs/shop/hooks'
import { Product } from 'src/Libs/shop/models/product.model'
import { useShopChannelRules } from 'src/Libs/shop/hooks/use-shop-channel-type'

interface AdditionalComponentPowerMeterCategoryCardProps {
  productData: Element[]
  availableSmartMeters: Product[] | null
}

const useStyles = makeStyles()(theme => ({
  gridContainer: {
    display: 'flex',
    overflowX: 'auto',
    width: '100%',
    minWidth: '30px',
    flexWrap: 'nowrap',
    marginLeft: '12px',
    position: 'relative',
  },
  paperContent: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflowX: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      paddingRight: 0,
    },
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: -20,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
}))

/*
 * This component shows available power meters into additional components category on system configurator
 */
const AdditionalComponentPowerMeterCategoryCard: React.FC<AdditionalComponentPowerMeterCategoryCardProps> = ({
  productData,
  availableSmartMeters,
}) => {
  const { t } = useCustomTranslation()
  const { containerRef, canScrollToLeft, canScrollToRight, handleScrollLeft, handleScrollRight } = useShopHorizontalScroll()
  const { classes } = useStyles()
  const productsLength = productData.length > 0 ? `(${productData.length})` : ''
  const { allowPowerMeter, allowSmartMeter } = useShopChannelRules()

  if (!allowPowerMeter && !allowSmartMeter) return null
  return (
    <Paper title={`${t('shop.additional-component.power-meter-text')} ${productsLength}`} className={classes.paperContent}>
      <Box className={classes.gridContainer} ref={containerRef}>
        {allowSmartMeter && <SmartMeterCard availableSmartMeters={availableSmartMeters} />}
        {allowPowerMeter && <AddPowerMeterCard />}
        {productData.map(transformer => (
          <AdditionalComponentPowerMeterProductCard key={transformer.id} productData={transformer} />
        ))}
      </Box>
      {canScrollToLeft && <J1LeftarrowA className={classes.leftArrow} onClick={handleScrollLeft} />}
      {canScrollToRight && <J1RightarrowA className={classes.rightArrow} onClick={handleScrollRight} />}
    </Paper>
  )
}

export default AdditionalComponentPowerMeterCategoryCard
